import { Button } from '@repo/atomic-components';
import { UsersSearchTextControl } from './UsersSearchTextControl';
import { useAccessControl } from '@/hooks';
import { AccessControlAction, AppRoutes } from '@/constants';
import { NavLink } from 'react-router';
import { classNames } from 'primereact/utils';

interface ActionsPanel {
  handleCreateNewUser: () => void;
}

export const ActionsPanel = ({ handleCreateNewUser }: ActionsPanel) => {
  const isAddEditUsers = useAccessControl(AccessControlAction.ADD_EDIT_USERS);

  const tabClass = (active: boolean) =>
    classNames(
      'flex h-8 items-center rounded-full border px-3 text-sm font-semibold whitespace-nowrap transition-colors',
      active
        ? 'border-fletchers-green-600 bg-fletchers-green-50 text-fletchers-green-600'
        : 'border-fletchers-gray-110 text-fletchers-black-900 hover:bg-fletchers-gray-50',
    );

  return (
    <div className="bg-fletchers-gray-25 flex h-full w-full flex-row items-center gap-2 px-6 py-4">
      <span className="mr-auto text-[20px] font-semibold whitespace-nowrap">User List</span>

      <div className="flex items-center gap-2">
        <NavLink
          to={`/${AppRoutes.UserManagement}/${AppRoutes.ActiveUsers}`}
          className={({ isActive }) => tabClass(isActive)}
        >
          Active users
        </NavLink>
        <NavLink
          to={`/${AppRoutes.UserManagement}/${AppRoutes.DeactivatedUsers}`}
          className={({ isActive }) => tabClass(isActive)}
        >
          Deactivated users
        </NavLink>
      </div>

      <div className="bg-fletchers-gray-110 mx-2 h-[30px] w-px" />

      <div className="w-4xs">
        <UsersSearchTextControl />
      </div>

      {isAddEditUsers && (
        <Button
          className="whitespace-nowrap [&_.pi]:text-[12px] [&>span]:font-semibold"
          label="Create user"
          icon="pi pi-plus"
          onClick={handleCreateNewUser}
          style={{ height: 32, paddingTop: 0, paddingBottom: 0, paddingLeft: 16, paddingRight: 16 }}
        />
      )}
    </div>
  );
};
